import { t } from '../../i18n.es.js';
import React, { useState, useEffect } from 'react';
import { calculateTimeDelta } from '../../helpers/time.es.js';
import { styled, Caption } from '@teko/ds-desktop';
import { getComponentSize } from '../../helpers/index.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

const addPaddingNumber = (number) => number.toString().padStart(2, "0");
const SIZE = {
  s: {
    level: 3
  },
  m: {
    level: 1
  }
};
const CountdownTime = ({
  endAt
}) => {
  const { isMobile } = useDevice();
  const size = getComponentSize(isMobile);
  const [duration, setDuration] = useState(calculateTimeDelta(new Date(), endAt));
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (duration.milliseconds !== 0) {
        setDuration(calculateTimeDelta(new Date(), endAt));
      }
    }, 1e3);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const displayCountdown = () => {
    if (duration.days !== 0) {
      return t("C\xF2n {{DurationDays}} ng\xE0y", { DurationDays: duration.days });
    }
    return `${addPaddingNumber(duration.hours)}:${addPaddingNumber(duration.minutes)}:${addPaddingNumber(duration.seconds)}`;
  };
  return /* @__PURE__ */ React.createElement(Timer, {
    level: SIZE[size].level,
    weight: "bold",
    color: "white"
  }, displayCountdown());
};
const Timer = styled(Caption)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export { CountdownTime };
